import { LocalizationProvider as Provider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import React from 'react'
import { IntlProvider } from 'react-intl'
import { getLocale, getLocaleFns } from './get-locale'
import { getMessages } from './messages'

const LocalizationProvider: React.FunctionComponent<React.PropsWithChildren> = ({ children }) => {
  const currentLocale = getLocale()
  const messages = getMessages(currentLocale)
  return (
    <Provider
      dateAdapter={AdapterDayjs}
      key={currentLocale}
      adapterLocale={getLocaleFns(currentLocale)}>
      <IntlProvider
        key={currentLocale} // Add the key prop to make sure the app is re-rendered when changing locale
        locale={currentLocale}
        messages={messages}>
        {children}
      </IntlProvider>
    </Provider>
  )
}

export default LocalizationProvider
